import { DialogType } from "@fluentui/react";
import { IFormField, IGenericOption } from "./CommonTypes";

import * as commonCode from "./components/request/RequestCommonCode";

export const constBearbStatusL = "läuft";
export const constBearbStatusE = "abgeschlossen";
export const constBearbStatusA = "abgebrochen";
export const constBearbStatusI = "inaktiv";

// MS Graph Properties
export const graphUserDisplayNameProperty = "displayName";
export const graphUserFirstNameProperty = "givenName";
export const graphUserLastNameProperty = "surname";
export const graphUserDepartmentProperty = "department";

// ============ ListNames =============
export const constLNCompanies = "Kunden";
// export const constLNVarianten = "Varianten";

// RegEx
export const FirmaInvalidCharRegex = /[^a-zäöüßA-ZÄÖÜẞ0-9 ().&'-]+/g;
export const BetriebInvalidCharRegex = /[^a-zA-Z0-9/ .,'@äöüÄÖÜß]/g;
export const GebaeudeInvalidCharRegex = /[^a-zA-Z0-9/ .,'@äöüÄÖÜß-]/g;
export const NameInvalidCharRegex = /[^a-zA-Z0-9/.,' ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿıŒœŠšŸŽž-]/g;
export const EmailInvalidCharRegex = /[^a-zA-Z0-9.@-]/g;
export const PhoneInvalidCharRegex = /[^0-9 -+]/g;            // /[^0-9 -]/g (was like this in Stromnetze)
export const NumberInvalidCharRegex = /[^0-9,]/g;

export const constGenericDropdownPlaceholder = "wählen Sie eine Option"

export const FirmaMaxLength = 50;

export const requiredMessage: string = " ist ein Pflichtfeld";

export const constVarianteKeyErstanforderung = "Erstanforderung";
export const constVarianteKeyAenderung = "Änderungsmitteilung";
export const constVarianteKeyAbmeldung = "Abmeldung";
export const constVarianteKeySonderfall = "Sonderfall";

export const months = [
    { text: "Jan.", key: 1 },
    { text: "Feb.", key: 2 },
    { text: "März", key: 3 },
    { text: "Apr.", key: 4 },
    { text: "Mai", key: 5 },
    { text: "Juni", key: 6 },
    { text: "Juli", key: 7 },
    { text: "Aug.", key: 8 },
    { text: "Sept.", key: 9 },
    { text: "Okt.", key: 10 },
    { text: "Nov.", key: 11 },
    { text: "Dez.", key: 12 },
  ];
  
export const DateStrings = {
    months: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ],
  
    shortMonths: [
      "Jan.",
      "Feb.",
      "März",
      "Apr.",
      "Mai",
      "Juni",
      "Juli",
      "Aug.",
      "Sept.",
      "Okt.",
      "Nov.",
      "Dez.",
    ],
  
    days: [
      "Montag",
      "Dienstag",
      "Mittwoch",
      "Donnerstag",
      "Freitag",
      "Samstag",
      "Sonntag",
    ],
  
    shortDays: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
  
    goToToday: "",
    prevMonthAriaLabel: "Go to previous month",
    nextMonthAriaLabel: "Go to next month",
    prevYearAriaLabel: "Go to previous year",
    nextYearAriaLabel: "Go to next year",
  };


export const dialogContentProps = {
    type: DialogType.normal,
    title: "Validation",
    closeButtonAriaLabel: "Close",
    subText: "Variante is not selected!",
  };  

export const YesOrNoOPSConsts: IGenericOption[] = [
  { key: "ja", text: "ja" },
  { key: "nein", text: "nein" },
];    

export const BetriebsweiseOPSConsts: IGenericOption[] = [
  { key: "kontinuierlich",  text: "kontinuierlich" },
  { key: "diskontinuierlich", text: "diskontinuierlich" },
];


export const constFTypeTextField = "TextField";
export const constFTypeMLTextField = "MLTextField";
export const constFTypeComboBox = "ComboBox";
export const constFTypeDropdown = "Dropdown";
export const constFTypeChoiceGroup = "ChoiceGroup";
export const constFTypeCheckListCheckbox = "CheckListCheckbox";
export const constFTypeDatePicker = "DatePicker";
export const constFTypeDropdownYesOrNo = "DropdownYesOrNo";



export const FormFieldsCommon: IFormField[] = [
  {
    Id:    "AntragstellerFirma",
    Label:     "Antragsteller Firma",
    FieldType: constFTypeComboBox,
    required: true
  },
  {
    Id:    "Betrieb",
    Label:     "Betrieb",
    FieldType: constFTypeTextField,
    required:  false
  },
  {
    Id:    "Gebaeude",
    Label:     "Gebäude",
    FieldType: constFTypeTextField,
    required: true
  },
  { 
    Id: "AntragstellerVorname",
    Label: "Antragsteller Vorname",
    FieldType: constFTypeTextField,
    required: true,
  },
  {
    Id: "AntragstellerNachname",
    Label: "Antragsteller Nachname",
    FieldType: constFTypeTextField,
    required: true
  },
  {
    Id:    "AntragstellerEmail",
    Label:     "Antragsteller E-Mail",
    FieldType: constFTypeTextField,
    required: true
  },
  {
    Id:    "AntragstellerTelefon",
    Label:     "Antragsteller Telefon",
    FieldType: constFTypeTextField,
    required: true
  },
  {
    Id:    "AntragstellerIsAnschlussnehmer",
    Label:     "Antragsteller ist auch verantwortlicher Anschlussnehmer",
    FieldType: constFTypeDropdown,
    ErrPrefix: "    Antragsteller ist auch verantwortlicher Anschlussnehmer",
    required:  true,
    used:      commonCode.FormIsSN
  },
  {
    Id:    "AnschlussnehmerVorname",
    Label:     "Anschlussnehmer Vorname",
    FieldType: constFTypeTextField,
    required: true,
    used:      commonCode.FormIsSNOtherUser
  },
  {
    Id:    "AnschlussnehmerNachname",
    Label:     "Anschlussnehmer Nachname",
    FieldType: constFTypeTextField,
    required: true,
    used:      commonCode.FormIsSNOtherUser
  },
  {
    Id:    "AnschlussnehmerEmail",
    Label:     "Anschlussnehmer Email",
    FieldType: constFTypeTextField,
    required: true,
    used:      commonCode.FormIsSNOtherUser
  },
  {
    Id:    "AnschlussnehmerTelefon",
    Label:     "Anschlussnehmer Telefon",
    FieldType: constFTypeTextField,
    required: true,
    used:      commonCode.FormIsSNOtherUser
  },
  {
    Id:    "AntragsVariante",
    Label:     "",
    FieldType: constFTypeChoiceGroup,
    ErrPrefix: "Variante",
    required: true
  },
  // {
  //   IdName:    "BemerkungAntragsteller",
  //   Label:     "Bemerkung Antragteller",       // different in SN and RM!
  //   FieldType: constFTypeTextField,
  //   required: false
  // },
  {
    Id:    "BedarfsterminGeschaetzt",
    Label:     "Bedarfstermin voraussichtlich ab",
    FieldType: constFTypeTextField,
    ErrPrefix: "Bedarfstermin",         //?
    required:  true
  },
  { // 
    Id:    "KontoEnergieverrechnung",                              
    Label:     "Konto für Energieverrechnung",
    FieldType: constFTypeTextField,
    ErrPrefix: "Sofern Antragsteller ISG",
    required:  true,
    used:      commonCode.CompanyIsISG
  }
]

